import { render } from "./indexAutoVision.vue?vue&type=template&id=2323043d&scoped=true"
import script from "./indexAutoVision.vue?vue&type=script&lang=js"
export * from "./indexAutoVision.vue?vue&type=script&lang=js"

import "./indexAutoVision.vue?vue&type=style&index=0&id=2323043d&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2323043d"]])

export default __exports__